<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-row class="overflow-hidden">
                    <loginSVG class="loginSVG"
                              :colors="loginSVGColors">

                    </loginSVG>
                    <v-row align="center" justify="center" class="d-flex flex-column c-search">
                        <br v-if="$experience.logoSecondLogin" />
                        <br v-if="$experience.logoSecondLogin" />
                        <span class="text-xlarge mb-4 text-center better-break"
                              :class="SVGFontColor ? 'SVGFontColor' : 'white--text'">{{$t('faq.howCanWeHelpYou')}}</span>
                        <span class="c-search-field">
                            <v-text-field class="ml-2 my-1"
                                          background-color="white"
                                          type="text"
                                          outlined
                                          dense
                                          hide-details
                                          clearable
                                          maxlength="255"
                                          v-model="search"
                                          prepend-inner-icon="mdi-magnify"
                                          :label="$t('faq.searchFAQ')"
                                          :aria-label="$t('faq.searchFAQ')">

                            </v-text-field>
                        </span>
                    </v-row>
                </v-row>
                <v-row>
                    <v-card width="100%"
                            :class="isMobile ? ['ma-2', 'pa-2', 'rounded-lg'] : ['ma-5', 'pa-9', 'rounded-xl']"
                            flat>
                        <v-card-text>
                            <v-row>
                                <v-col :cols="isMobile ? 12 : 8">
                                    <v-expansion-panels v-model="openedFAQ"
                                                        class="c-expansion-panels">
                                        <v-expansion-panel class="c-expansion-panel mb-2 rounded-lg"
                                                           :class="expansionPanelFontColor ? 'c-expansion-panel-border-color' : 'c-expansion-panel-border-color-primary'"
                                                           v-for="(faq,idx) in filteredFAQs"
                                                           :key="faq.Id"
                                                           role="region"
                                                           :aria-labelledby="`faq-header-${idx}`">
                                            <v-expansion-panel-header disable-icon-rotate
                                                                      hide-actions
                                                                      role="button"
                                                                      :id="`faq-header-${idx}`"
                                                                      @keydown.enter="openedFAQ = openedFAQ === idx ? null : idx"
                                                                      @keydown.space="openedFAQ = openedFAQ === idx ? null : idx">
                                                <span class="justify-start text-normal font-weight-medium"
                                                      :class="expansionPanelFontColor ? 'expansionPanelFontColor' : 'primary--text'"><v-icon class="mr-2" :color="expansionPanelFontColor ? 'expansionPanelFontColor' : 'primary'" aria-hidden="true">{{openedFAQ === idx ? 'mdi-minus' : 'mdi-plus'}}</v-icon>{{$i18n.locale == 'fr' ? faq.QuestionFR : faq.QuestionEN}}</span>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <span v-html="$i18n.locale == 'fr' ? faq.AnswerFR : faq.AnswerEN" class="text-normal"></span>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-col>
                                <v-col :cols="isMobile ? 0 : 4">
                                    <v-expansion-panels v-model="openedDocumentRepository"
                                                        class="c-expansion-panels">
                                        <v-expansion-panel class="c-expansion-panel mb-2 rounded-lg"
                                                           :class="expansionPanelFontColor ? 'c-expansion-panel-border-color' : 'c-expansion-panel-border-color-primary'"
                                                           role="region"
                                                           aria-labelledby="document-repository-header">
                                            <v-expansion-panel-header role="button"
                                                                      id="document-repository-header"
                                                                      @keydown.enter="openedDocumentRepository = openedDocumentRepository === 0 ? null : 0"
                                                                      @keydown.space="openedDocumentRepository = openedDocumentRepository === 0 ? null : 0">
                                                <span class="justify-start text-normal font-weight-medium"
                                                      :class="expansionPanelFontColor ? 'expansionPanelFontColor' : 'primary--text'">{{$t('faq.documentRepository')}}</span>
                                                <template v-slot:actions>
                                                    <v-icon :color="expansionPanelFontColor ? 'expansionPanelFontColor' : 'primary'" aria-hidden="true">
                                                        $expand
                                                    </v-icon>
                                                </template>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content class="pa-4">
                                                <span v-if="documentsErrorMsg" class="text-normal">{{documentsErrorMsg}}</span>
                                                <v-row v-for="document in documents"
                                                       :key="document.Id"
                                                       class="my-2"
                                                       justify="space-between">

                                                    <span class="text-normal c-document-name">{{$i18n.locale == 'fr' ? document.DocumentNameFR : document.DocumentNameEN}}</span>

                                                    <span class="">
                                                        <v-icon class="mr-2"
                                                                @click="onDownloadClick(document.Id)"
                                                                :aria-label="$t('faq.downloadDocument')">mdi-download</v-icon>
                                                        <v-icon v-if="!isMobile" 
                                                                @click="onPreviewClick(document.Id)"
                                                                :aria-label="$t('faq.previewDocument')">mdi-eye-outline</v-icon>
                                                    </span>

                                                </v-row>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import loginSVG from '../../components/loginSVG.vue';

    export default {
        name: "FAQ",
        components: { loginSVG },
        data() {
            return {
                documents: [],
                documentsErrorMsg: '',
                search: '',
                faqs: [],
                openedFAQ: null,
                openedDocumentRepository: null,
                
            }
        },
        computed: {
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            },
            filteredFAQs() {
                if (!this.search) {
                    return this.faqs;
                }
                let results = [];
                results = this.faqs.filter(e => e.QuestionFR.toLowerCase().includes(this.search.toLowerCase())
                    || e.QuestionEN.toLowerCase().includes(this.search.toLowerCase())
                    || e.AnswerFR.toLowerCase().includes(this.search.toLowerCase())
                    || e.AnswerEN.toLowerCase().includes(this.search.toLowerCase())
                );

                return results;
            },
            loginSVGColors() {
                return this.$vuetify.theme.themes.light.loginSVG;
            },
            SVGFontColor() {
                return this.$vuetify.theme.themes.light.SVGFontColor;
            },
            expansionPanelFontColor() {
                return this.$vuetify.theme.themes.light.expansionPanelFontColor;
            },
            getSecondLogo() {
                return (this.$i18n.locale == 'en' && this.$experience.logoSecondLoginEN != null) ? this.$experience.logoSecondLoginEN : this.$experience.logoSecondLogin;
            },
            logoSecondLoginMaxWidth() {
                return this.$experience.logoSecondLoginMaxWidth;
            },
            logoSecondLoginMaxheight() {
                return this.$experience.logoSecondLoginMaxheight;
            }
        },
        mounted() {
            this.loadQuestions();
            this.loadDocuments();
        },
        methods: {
            loadDocuments() {
                return this.$axios.post("documentsrepository/getdocumentlist")
                    .then((response) => {
                        if (response.data.success) {
                            this.documents = response.data.documents;
                            this.documentsErrorMsg = '';
                        }
                        else if (response.data.success == false && response.data.error == 'session-expired') {
                            this.$router.push({ name: 'login' });
                        } 
                        else {
                            this.documents = [];
                            this.documentsErrorMsg = this.$t(response.data.msg);
                        }

                    })
                    .catch(() => {
                        this.documents = [];
                        this.documentsErrorMsg = this.$t('noDocumentFound');
                    })
            },
            loadQuestions() {
                return this.$axios.post("documentsrepository/list")
                    .then((response) => {
                        if (response.data.success == false && response.data.error == 'session-expired') {
                            this.$router.push({ name: 'login' });
                        } 
                        this.faqs = response.data.faqs;
                    })
            },
            onPreviewClick(documentId) {
                let downloadBaseUrl = "documentsrepository/getdocument",
                    downloadUrl = `${downloadBaseUrl}?documentId=${documentId}&actionNum=0`;

                return this.$axios.get(downloadUrl, { responseType: 'blob' })
                    .then((response) => {
                        if (response.data.success == false && response.data.error == 'session-expired') {
                            this.$router.push({ name: 'login' });
                        } 
                        const type = response.headers['content-type'] || null
                        const relType = 'application/pdf'

                        if (type.includes(relType)) {
                            let keyData = btoa(URL.createObjectURL(response.data));

                            let favicon = btoa(`./assets/Branding/${this.$experience.key}/Images/${this.$experience.favicon}`);
                            let branding = btoa(this.$experience.appTitle || "Vault");

                            globalThis.open(`preview.html?document=${keyData}&fav=${favicon}&branding=${branding}`, '_blank');
                        }
                    });
            },
            onDownloadClick(documentId) {
                let downloadBaseUrl = "documentsrepository/getdocument",
                    downloadUrl = `${downloadBaseUrl}?documentId=${documentId}&actionNum=1`;

                if (this.isMobile) {
                    globalThis.location = downloadUrl;
                }
                else {

                    return this.$axios.get(downloadUrl, { responseType: 'blob' })
                        .then((response) => {
                            if (response.data.success == false && response.data.error == 'session-expired') {
                                this.$router.push({ name: 'login' });
                            } 
                            const type = response.headers['content-type'] || null
                            const relType = 'application/pdf'

                            if (type.includes(relType)) {

                                const link = document.createElement('a');

                                link.href = globalThis.URL.createObjectURL(
                                    new Blob([response.data])
                                );
                                link.setAttribute('download', response.headers['content-disposition'].split('filename=')[1].split(';')[0]);
                                link.click();

                                return;
                            }
                        });
                }
            },
        }
    }
</script>

<style scoped>
    .c-document-name {
        max-width: 75% !important;
    }
    .c-expansion-panel {
        border-style: solid !important;
        border-width: 1px !important;
        border-radius: 8px !important;
        width: 100% !important;
    }
    .c-expansion-panel-border-color {
        border-color: var(--expansionPanelFontColor) !important;
    }
    .c-expansion-panel-border-color-primary {
        border-color: var(--primary) !important;
    }
    .v-expansion-panels {
        z-index: 0 !important;
    }
    .v-application .expansionPanelFontColor {
        color: var(--expansionPanelFontColor) !important;
        background-color: transparent !important;
    }
    .c-search {
        margin-top: -250px;
    }
    .c-search-field {
       width: 475px !important;
    }
    .loginSVG {
        height: 265px !important;
        width: 100% !important;

    }
    .v-application .SVGFontColor {
        color: var(--SVGFontColor);
        background-color: transparent !important;
    }
    /* for mobile */
    @media (max-width: 960px) {
        .c-search {
            margin-top: -200px;
        }
        .c-search-field {
            width: 300px !important;
        }

        .loginSVG {
            height: 175px !important;
            width: 100% !important;
        }
        
    }

</style>